export default __webpack_public_path__ + "static/media/imageErrorIdCardFirst.a57268d5.svg";